import { FunctionComponent } from "react";
import { Tenant } from "../src/types";

const TenantKindBadge: FunctionComponent<{ kind: Tenant["kind"] }> = ({
  kind,
}) => {
  switch (kind) {
    case "sandbox":
      return (
        <div className="text-xs text-white rounded font-bold bg-gray-500 uppercase py-0.5 px-1">
          developer
        </div>
      );
    case "production":
      return (
        <div className="text-xs text-white rounded font-bold bg-green-700 uppercase py-0.5 px-1">
          business
        </div>
      );
  }
};

export default TenantKindBadge;
